<template>
  <list-ais :image="image" />
</template>

<script>
import ListAis from '@/components/ai/ListAis';

export default {
  name: 'analysis',
  components: {
    ListAis,
  },
  props: {
    index: String
  },
  computed: {
    imageWrapper() {
      return this.$store.getters['currentProject/currentViewer'].images[this.index];
    },
    image() {
      return this.imageWrapper.imageInstance.clone();
    }
  }
};
</script>
